<template>
	<page-content-layout class="page" title="Statistics">
		<div class="layout" style="">
			<div class="bar">
				<div class="tools">
					<select-view class="light" label="Område" v-model="statistic" :options="options" :optional="true" />
					<date-select-view class="from light" v-model="from" label="Fra" :optional="true" :controller="$store.state.popupController" />
					<date-select-view class="to light" v-model="to" label="Til" :optional="true" :controller="$store.state.popupController" />
				</div>
				<perfect-scrollbar class="categories" style="box-sizing: border-box;">
					<div v-for="(f, i) in chart.filter" :key="i" class="item">
						{{ f.label }}
						<switch-view class="light" :value="filter.name == f.name" @input="setFilter(f, ...arguments)" />
					</div>
				</perfect-scrollbar>
				<div v-if="false" class="stats-btn" @click="basis()">
					Grundlag
				</div>
			</div>
			<apexchart class="chart" type="bar" :options="_chartOptions" :series="_chartSeries" style="" width="100%" height="100%" />
		</div>
	</page-content-layout>
</template>

<script>
	import { bus } from '../../bus'

    export default {
		data() {
			return {
				options: [
					{
						label: 'Antal pr. medarbejder',
						value: 'claims/employee'
					},
					{
						label: 'Antal pr. dag',
						value: 'claims/day'
					},
					{
						label: 'Omkostning pr. dag',
						value: 'claims-cost/day'
					}
				],
				statistic: 'claims/employee',
				from: (new Date()).format('Y-m-01'),
				to: (new Date()).format('Y-m-d'),
				filterUpdate: 0,
				filter: {
					name: '',
					categories: []
				},
				chart: {
					filter: [],
					categories: [],
					series: []
				}
			};
		},
		watch: {
			statistic(n) {
				this.categories = [];
				this.update();
			},
			from() {
				this.update();
			},
			to() {
				this.update();
			}
		},
		computed: {
			_filter() {
				var r = [];

				/*for (var i = 0; i < this.chart.categories.length; ++i) {
					if ( this.categories.includes(this.chart.categories[i])) {
						r.push(i);
					}
				}*/

				//if (this.categories.length == 0) return this.chart.categories;

				this.filterUpdate;

				const f = this.filter;

				

				for (var i = 0; i < this.chart.categories.length; ++i) {
					if (f === null || f.categories.length == 0 || f.categories.includes(i)) {
						r.push(i);
					}
				}

				

				return r;
			},
			_chartOptions() {
				var f = this._filter;

				return {
					chart: {
						id: 'chart'
					},
					xaxis: {
						categories: this.chart.categories.filter(function (item, index) { return f.includes(index) })
					},
					redrawOnParentResize: true
				};
			},
			_chartSeries() {
				var f = this._filter;
				var series = JSON.parse(JSON.stringify(this.chart.series));

				for (var i = 0; i < series.length; ++i) {
					//
					series[i].data = series[i].data.filter(function (item, index) { return f.includes(index); });
				}

				//

				return series;
			},
			_series() {
				const r = this.options.find(function (item) { return item.value = self.n; });
				return r !== null ? r.series : [];
			}
		},
		methods: {
			async update() {
				this.chart = (await this.axios.get('/statistics/' + this.statistic + '/?from=' + this.from + '&to=' + this.to)).data;
			},
			setFilter(filter, val) {
				

				this.filter = filter;
				this.filterUpdate++;
			},
			basis() {
				
				window.open(`${process.env.VUE_APP_API}statistics/basis/${this.$store.state.auth}/?statistic=${this.statistic}&from=${this.from}&to=${this.to}&filter=${this.filter.name}`);
			}
		},
		created() {
			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.chart.categories = [];
				self.chart.series = [];
			});
		},
		mounted() {
			this.update();
		}
    }
</script>

<style lang="scss" scoped>
	.page {
		height: auto;
	}

	.layout {
		position: absolute ! important;
		left: 0;
		top: 0;
		width: 100%;
		bottom: 0;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 100%;

		& > .bar {
			background-color: #F0F0F0;
			border-right: 1px solid #CECECE;
			display: grid;
			grid-template-rows: auto 1fr 50px;

			& > .tools {
				padding: 20px;

				& > div {
					margin-bottom: 20px;
				}
			}

			& > .categories {
				border-top: 1px solid #CECECE;
				padding: 20px;
				overflow-y: auto;

				& > .item {
					line-height: 26px;
					position: relative;
					font-size: 12px;

					& > .light {
						position: absolute;
						top: 3px;
						right: 0;
					}
				}
			}

			& > .stats-btn {
				background-color: rgb(71, 71, 71);
				color: white;
				text-align: center;
				line-height: 50px;
				cursor: pointer;
			}
		}

		& > .chart {
			box-sizing: border-box;
			height: 200px;
			min-height: 1px ! important;
			padding: 0;
		}
	}
</style>